import {skipWaiting as workbox_core_skipWaiting} from 'C:/LD/LDCOM13_ESTANDAR/FUENTES_LOTES/INTERFACE/SITE_POS_MONITOR/LD_POS_MONITOR/ClientApp/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'C:/LD/LDCOM13_ESTANDAR/FUENTES_LOTES/INTERFACE/SITE_POS_MONITOR/LD_POS_MONITOR/ClientApp/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/LD/LDCOM13_ESTANDAR/FUENTES_LOTES/INTERFACE/SITE_POS_MONITOR/LD_POS_MONITOR/ClientApp/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "./ClientApp/public/dist/0.b1d684cf9a28b92729a1.js",
    "revision": "3601654a23149325572735e260a9c68a"
  },
  {
    "url": "./ClientApp/public/dist/10.c658abb44136a28321f3.js",
    "revision": "b9e9c6cf8b507f6d7df00a2d9ea5b4f2"
  },
  {
    "url": "./ClientApp/public/dist/11.7deaad461877571c25b3.js",
    "revision": "add99a8d4944473e6669eb6c821782ed"
  },
  {
    "url": "./ClientApp/public/dist/12.81ad4344ce2281443199.js",
    "revision": "48b97e4af3b41cc906ef8542df94372c"
  },
  {
    "url": "./ClientApp/public/dist/4.bdb40930ec61b35b52db.js",
    "revision": "adb23a8388d848ff364a7320d2e7cb37"
  },
  {
    "url": "./ClientApp/public/dist/5.d79b86225d7c0bc5a738.js",
    "revision": "c3496ab7b3928dce62f6a5024d5e2380"
  },
  {
    "url": "./ClientApp/public/dist/6.74b24f7f23ca5b0137e0.js",
    "revision": "3d8f520198d8fa7bb66f5c8ca036ef1b"
  },
  {
    "url": "./ClientApp/public/dist/7.3ffa8ed5b66692edce12.js",
    "revision": "850a83d606bff5d66053dbe05125c14f"
  },
  {
    "url": "./ClientApp/public/dist/8.ea9755cd48144f6029e4.js",
    "revision": "6048c93680dace6098001227ac82aac0"
  },
  {
    "url": "./ClientApp/public/dist/9.4a305108b893e400ca34.js",
    "revision": "d34581938323ad13d3ae9acfebdb10da"
  },
  {
    "url": "./ClientApp/public/dist/runtimechunk~app.42d4a4802e7e0d2bc812.js",
    "revision": "6de2939be549a2eb851beb76fbbec34e"
  }
], {});








